/* eslint-disable */
import { FormEditFieldCreateDialogView, FormEditFieldDialogViewFactory, FormEditFieldUpdateDialogView } from './form-utils';
import { ComponentFactoryResolver, ComponentRef, Injector } from '@angular/core';
import { FormEditCreateUpdateUserFieldDialogComponent } from '../../admin/form/form-edit/dialogs/fields/user/create-edit/form-edit-create-update-user-field-dialog.component';
/* eslint-enable */

export class FormEditUserFieldDialogViewFactory implements FormEditFieldDialogViewFactory {

  constructor(
    private injector: Injector,
    private cfr: ComponentFactoryResolver) {
  }

  createCreateView(): ComponentRef<FormEditFieldCreateDialogView> {
    return this.createView();
  }

  createUpdateView(): ComponentRef<FormEditFieldUpdateDialogView> {
    return this.createView();
  }

  private createView(): ComponentRef<FormEditCreateUpdateUserFieldDialogComponent> {
    return this.cfr.resolveComponentFactory(FormEditCreateUpdateUserFieldDialogComponent)
      .create(this.injector);
  }

}
